import { put, takeEvery, call } from "redux-saga/effects";
import {
  FETCH_EXPIRYRETURNDETAILS_INIT_ACTION,
  FETCH_EXPIRYRETURNDETAILS_SUCCESS_ACTION,
  FETCH_EXPIRYRETURNDETAILS_FAIL_ACTION,
  FETCH_EXPIRYRETURNVIEW_INIT_ACTION,
  FETCH_EXPIRYRETURNVIEW_SUCCESS_ACTION,
  FETCH_EXPIRYRETURNVIEW_FAIL_ACTION,
  PDF_EXPIRY_RETURN_REPORT_INIT_ACTION,
  PDF_EXPIRY_RETURN_REPORT_SUCCESS_ACTION,
  PDF_EXPIRY_RETURN_REPORT_FAIL_ACTION,
  FETCH_EXPIRY_RETUNREJECTED_INIT_ACTION,
  FETCH_EXPIRY_RETUNACCEPTED_INIT_ACTION,
  FETCH_EXPIRY_ORDERDETAIL_ACCEPT_INIT,
  FETCH_EXPIRY_ORDERDETAIL_REJECT_INIT,
  UPDATE_EXPIRY_APPROVED_QTY_INIT,
  UPDATE_EXPIRY_APPROVED_QTY_SUCCESS,
  UPDATE_EXPIRY_APPROVED_QTY_FAIL,
  UPDATE_EXPIRY_PURCHASEORDER_TOTALS_INIT,
  UPDATE_EXPIRY_PURCHASEORDER_TOTALS_SUCCESS,
  UPDATE_EXPIRY_PURCHASEORDER_TOTALS_FAIL,
} from "./action";

import { appConfig } from "../../config";
import { toast, Flip } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import jsPDF from "jspdf";
import "jspdf-autotable";

function* fetchExpiryReturns(value) {
  const token = localStorage.getItem("token");
  const distributorProfId = localStorage.getItem("distributorId");

  const pageno =
    !value.value || value.value.page === undefined
      ? 1
      : value.value.page;

  const searchquery =
    !value.value || value.value.searchquery === undefined
      ? ""
      : value.value.searchquery;

  const status =
    !value.value || value.value.filter === undefined
      ? ""
      : value.value.filter;

  try {
    const res = yield fetch(
      `${appConfig.ip}/purchaseOrder?orderType=expiryReturn&orderTo=${distributorProfId}&search=${searchquery}&status=${status}&limit=10&page=${pageno}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (!res.ok) throw res;

    const resJSON = yield res.json();

    yield put({
      type: FETCH_EXPIRYRETURNDETAILS_SUCCESS_ACTION,
      payload: resJSON,
    });
  } catch (err) {
    yield put({
      type: FETCH_EXPIRYRETURNDETAILS_FAIL_ACTION,
      error: err,
    });
  }
}

/* ============================
   2️⃣ Fetch Expiry Return Items
   ============================ */
function* fetchExpiryReturnView(value) {
  const token = localStorage.getItem("token");

  const orderId = value.value.item.item.id;
  const pageno = value.value.page === undefined ? 1 : value.value.page;

  try {
    const res = yield fetch(
      `${appConfig.ip}/orderDetails?orderId=${orderId}&limit=5&page=${pageno}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (!res.ok) throw res;

    const resJSON = yield res.json();

    yield put({
      type: FETCH_EXPIRYRETURNVIEW_SUCCESS_ACTION,
      payload: resJSON,
    });
  } catch (err) {
    yield put({
      type: FETCH_EXPIRYRETURNVIEW_FAIL_ACTION,
      error: err,
    });
  }
}

function* returnrejected(value) {
  const token = localStorage.getItem("token");
  const orderId = value.value.order.item.id;

  const {
    approvedQtyMap,
    approvedAmountMap,
    totalApprovedAmount,
    totalClaimAmount,
  } = value.value;

  try {
    yield call(updatePurchaseOrderTotalsSaga, {
      value: {
        orderId,
        totalApprovedAmount,
        totalClaimAmount,
      },
    });

    yield fetch(`${appConfig.ip}/purchaseOrder/changeStatus/${orderId}`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ status: "rejected" }),
    });

    for (const itemId in approvedQtyMap) {
      yield put({
        type: UPDATE_EXPIRY_APPROVED_QTY_INIT,
        value: {
          id: itemId,
          approvedQntty: approvedQtyMap[itemId],
          approvedAmount: approvedAmountMap[itemId],
        },
      });
    }

    yield toast.success("Expiry return rejected", {
      autoClose: 3000,
      transition: Flip,
    });

    yield put({ type: FETCH_EXPIRYRETURNDETAILS_INIT_ACTION });
  } catch (err) {
    console.error(err);
  }
}

function* returnaccept(value) {
  const token = localStorage.getItem("token");
  const orderId = value.value.order.item.id;

  const {
    approvedQtyMap,
    approvedAmountMap,
    totalApprovedAmount,
    totalClaimAmount,
  } = value.value;

  try {
    yield call(updatePurchaseOrderTotalsSaga, {
      value: {
        orderId,
        totalApprovedAmount,
        totalClaimAmount,
      },
    });

    yield fetch(`${appConfig.ip}/purchaseOrder/changeStatus/${orderId}`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ status: "accepted" }),
    });

    for (const itemId in approvedQtyMap) {
      yield put({
        type: UPDATE_EXPIRY_APPROVED_QTY_INIT,
        value: {
          id: itemId,
          approvedQntty: approvedQtyMap[itemId],
          approvedAmount: approvedAmountMap[itemId],
        },
      });
    }

    yield toast.success("Expiry return accepted", {
      autoClose: 3000,
      transition: Flip,
    });

    yield put({ type: FETCH_EXPIRYRETURNDETAILS_INIT_ACTION });
  } catch (err) {
    console.error(err);
  }
}

function* returnacceptOne(value) {
  let datas = { orderStatus: "approved" };
  const { id, orderId, approvedQntty, approvedAmount } = value.value;
  const token = localStorage.getItem("token");

  try {
    yield put({
      type: UPDATE_EXPIRY_APPROVED_QTY_INIT,
      value: {
        id,
        approvedQntty,
        approvedAmount,
      },
    });

    const res = yield fetch(`${appConfig.ip}/orderDetails/changeStatus/${id}`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(datas),
    });

    if (!res.ok) throw res;

    yield toast.success("Item accepted", {
      autoClose: 3000,
      transition: Flip,
    });

    yield put({
      type: FETCH_EXPIRYRETURNVIEW_INIT_ACTION,
      value: {
        item: { item: { id: orderId } },
        page: 1,
      },
    });

    yield put({
      type: FETCH_EXPIRYRETURNDETAILS_INIT_ACTION,
      value: {
        page: 1,
        filter: "",
        searchquery: "",
      },
    });
  } catch (err) {
    console.error(err);
  }
}

function* returnrejectedOne(value) {
  let datas = { orderStatus: "rejected" };
  const { id, orderId, approvedQntty, approvedAmount } = value.value;
  const token = localStorage.getItem("token");
  try {
    yield put({
      type: UPDATE_EXPIRY_APPROVED_QTY_INIT,
      value: {
        id,
        approvedQntty,
        approvedAmount,
      },
    });

    const res = yield fetch(`${appConfig.ip}/orderDetails/changeStatus/${id}`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(datas),
    });

    if (!res.ok) throw res;

    yield toast.success("Item Rejected", {
      autoClose: 3000,
      transition: Flip,
    });

    yield put({
      type: FETCH_EXPIRYRETURNVIEW_INIT_ACTION,
      value: {
        item: { item: { id: orderId } },
        page: 1,
      },
    });

    yield put({
      type: FETCH_EXPIRYRETURNDETAILS_INIT_ACTION,
      value: {
        page: 1,
        filter: "",
        searchquery: "",
      },
    });
  } catch (err) {
    console.error(err);
  }
}

function* updateApprovedQuantity(value) {
  const token = localStorage.getItem("token");
  const { id, approvedQntty, approvedAmount } = value.value;

  try {
    const res = yield fetch(`${appConfig.ip}/orderDetails/${id}`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        approvedQntty,
        approvedAmount,
      }),
    });

    if (!res.ok) throw res;

    yield put({
      type: UPDATE_EXPIRY_APPROVED_QTY_SUCCESS,
      payload: {
        id,
        approvedQntty,
        approvedAmount,
      },
    });

    yield put({ type: FETCH_EXPIRYRETURNDETAILS_INIT_ACTION });
  } catch (err) {
    yield put({ type: UPDATE_EXPIRY_APPROVED_QTY_FAIL, error: err });
  }
}

function* updatePurchaseOrderTotalsSaga(action) {
  const token = localStorage.getItem("token");
  const { orderId, totalApprovedAmount, totalClaimAmount } = action.value;

  try {
    const res = yield fetch(`${appConfig.ip}/purchaseOrder/${orderId}`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        totalApprovedAmount,
        totalClaimAmount,
      }),
    });

    if (!res.ok) throw res;

    yield put({
      type: UPDATE_EXPIRY_PURCHASEORDER_TOTALS_SUCCESS,
      payload: {
        orderId,
        totalApprovedAmount,
        totalClaimAmount,
      },
    });
  } catch (err) {
    yield put({
      type: UPDATE_EXPIRY_PURCHASEORDER_TOTALS_FAIL,
      error: err,
    });
  }
}

/* ============================
   3️⃣ PDF for Expiry Returns
   ============================ */
function* pdfExpiryReturnFullData(value) {
  const token = localStorage.getItem("token");

  const orderId = value.value.item.orderDetail.orderId.id;
  const ordername = value.value.item.orderFrom.fullName;
  const ordermob = value.value.item.orderFrom.mobileNo;
  const orderNo = value.value.item.orderNo;
  const email = value.value.item.chmstDtls.email;
  const address = value.value.item.addr + value.value.item.pincode;
  const pharmacy = value.value.item.orderFrom.orgName;
  const city = value.value.item.city;

  try {
    const res = yield fetch(
      `${appConfig.ip}/orderDetails?orderId=${orderId}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (!res.ok) throw res;

    const resJSON = yield res.json();
    const count = resJSON.count;

    const doc = new jsPDF("p", "mm", "a4");

    const tableColumn = [
      "#",
      "Item Code",
      "Item Name",
      "Qnt",
      "Batch No",
      "Claim Amt",
      "Purchase Inv No",
      "Purchase Date",
      "Expiry Date",
    ];

    const tableRows = [];

    resJSON.rows.forEach((report, i) => {
      tableRows.push([
        i + 1,
        report.itemCode?.drugCode || "-",
        report.itemCode?.drugName || "-",
        report.qntty || "-",
        report.batchNo || "-",
        report.claimAmount || "-",
        report.purchaseInvoiceNo || "-",
        report.purchaseDate
          ? new Date(report.purchaseDate).toLocaleDateString()
          : "-",
        report.expiryDate
          ? new Date(report.expiryDate).toLocaleDateString()
          : "-",
      ]);
    });

    doc.autoTable(tableColumn, tableRows, {
      theme: "grid",
      styles: { halign: "left" },
      headerStyles: { fillColor: [255, 0, 0], halign: "center" },
      margin: { top: 65 },
    });

    doc.setFontSize(10);
    doc.text(`Order No : ${orderNo}`, 11, 13);
    doc.text(`Name : ${ordername}`, 11, 19);
    doc.text(`Pharmacy : ${pharmacy}`, 11, 25);
    doc.text(`Mobile : ${ordermob}`, 11, 30);
    doc.text(`Email : ${email}`, 11, 35);
    doc.text(`Address : ${address}`, 11, 40);
    doc.text(`City : ${city}`, 11, 45);

    doc.setFontSize(13);
    doc.text("Item Details", 11, 55);
    doc.setFontSize(12);
    doc.text(`${count} Items`, 11, 60);

    doc.save(`${ordername}- ${orderNo}.pdf`);

    yield put({
      type: PDF_EXPIRY_RETURN_REPORT_SUCCESS_ACTION,
      payload: resJSON,
    });
  } catch (err) {
    yield put({
      type: PDF_EXPIRY_RETURN_REPORT_FAIL_ACTION,
      error: err,
    });
  }
}

/* ============================
   4️⃣ Watcher
   ============================ */
export function* ExpiryReturnsActionWatcher() {
  yield takeEvery(
    FETCH_EXPIRYRETURNDETAILS_INIT_ACTION,
    fetchExpiryReturns
  );

  yield takeEvery(
    FETCH_EXPIRYRETURNVIEW_INIT_ACTION,
    fetchExpiryReturnView
  );

  yield takeEvery(
    PDF_EXPIRY_RETURN_REPORT_INIT_ACTION,
    pdfExpiryReturnFullData
  );

  yield takeEvery(FETCH_EXPIRY_RETUNREJECTED_INIT_ACTION, returnrejected);
  yield takeEvery(FETCH_EXPIRY_RETUNACCEPTED_INIT_ACTION, returnaccept);
  yield takeEvery(FETCH_EXPIRY_ORDERDETAIL_ACCEPT_INIT, returnacceptOne);
  yield takeEvery(FETCH_EXPIRY_ORDERDETAIL_REJECT_INIT, returnrejectedOne);
  yield takeEvery(UPDATE_EXPIRY_APPROVED_QTY_INIT, updateApprovedQuantity);
  yield takeEvery(
    UPDATE_EXPIRY_PURCHASEORDER_TOTALS_INIT,
    updatePurchaseOrderTotalsSaga
  );
}
